import React, { Component } from "react";
import {
  Button,
  Row,
  Label,
  FormGroup,
  Col,
  Input,
  FormText,
} from "reactstrap";
import * as Constdata from "../../Constants/ApiConstants";
import * as message from "../../Constants/MessageConstant";
import SerraLoader from "../CommonComponent/Loader";
import SerraError from "../CommonComponent/Error";

class GpuPreferences extends Component {
  constructor(props) {
    super(props);
    this.saveGPUPreference = this.saveGPUPreference.bind(this);
    this.setErrorPopupState = this.setErrorPopupState.bind(this);
    this.changeGPUCountLimit = this.changeGPUCountLimit.bind(this);
    this.state = {
      enableSave: false,
      errorPopup: false,
      modalLoader: false,
      isErrorHeader: true,
      errormessage: "",
      isRedirect: false,
      provider: props.providerName,
      userName: props.userName,
      isFreeTrial: props.isFreeTrial,
      isGpuCountLimitEnabled: false,
      gpuCountLimit: 0,
    };
  }

  setErrorPopupState = (event) => {
    this.setState({ errorPopup: event });
    if (this.state.isRedirect) {
      this.props.history.push("/");
    }
  };

  saveGPUPreference() {
    this.setState({ modalLoader: true });

    let payload = {
      providerName: this.props.providerName,
      orgId: this.props.orgId,
      gpuCountLimit: this.state.gpuCountLimit,
      isGpuCountLimitEnabled: this.state.isGpuCountLimitEnabled,
    };

    fetch(`${Constdata.SET_GPU_RECOMMENDATION_PREFERENCES}`, {
      method: "Post",
      credentials: "include",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json;charset=UTF-8",
      },
      body: JSON.stringify(payload),
    })
      .then((response) => response.json())
      .then((responseJson) => {
        this.setState({ modalLoader: false });
        this.props.handleGPUPreferenceRequest(responseJson);
      })
      .catch((error) => {
        console.error(error);
      });
  }

  async componentDidMount() {
    await this.setState({ modalLoader: true });
    this.props.registerListners(true);

    let payload = {
      providerName: this.props.providerName,
      orgId: this.props.orgId,
      gpuCountLimit: null,
    };

    fetch(`${Constdata.SET_GPU_RECOMMENDATION_PREFERENCES}`, {
      method: "POST",
      credentials: "include",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json;charset=UTF-8",
      },
      body: JSON.stringify(payload),
    })
      .then((response) => response.json())
      .then(async (responseJson) => {
        if (responseJson.success === true) {
          await this.setState({
            modalLoader: false,
            gpuCountLimit: responseJson.data.gpuCountLimit,
            isGpuCountLimitEnabled: responseJson.data.isGpuCountLimitEnabled,
          });
        } else if (responseJson.status === 403 || responseJson.status === 401) {
          await this.setState({
            modalLoader: false,
            errorPopup: true,
            errormessage: message.SessionExpiredText,
            isErrorHeader: false,
          });
        } else {
          await this.setState({
            modalLoader: false,
            errorPopup: true,
            errormessage: message.ServerError,
            isErrorHeader: false,
            isRedirect: false,
          });
        }
      })
      .catch((error) => {
        console.error(error);
        this.setState({
          modalLoader: false,
          errorPopup: true,
          errormessage: message.CacheErrorText,
          isErrorHeader: false,
          isRedirect: false,
        });
      });
  }
  changeGPUCountLimit(value) {
    this.setState({ gpuCountLimit: value });
  }

  handleRadioChange = (e) => {
    const isEnabled = e.target.value === "true";
    this.setState({ isGpuCountLimitEnabled: isEnabled });
    if (!isEnabled) this.setState({ isGpuCountLimitEnabled: "" }); // reset if disabled
  };

  render() {
    return (
      <div>
        <div
          className="container-verf container-verf-margin pageBgWhite"
          style={{ borderRadius: "10px" }}
          role="main"
        >
          <div className="frm-container">
            <Row
              style={{
                justifyContent: "center",
                borderBottom: "1px solid #c9c9c9",
                paddingBottom: "30px",
              }}
            >
              <FormGroup tag="fieldset">
                {/* <Label className="fw-bold">GPU Count Limit</Label> */}

                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    gap: 40,
                    justifyContent: "center",
                  }}
                >
                  <div>
                    {" "}
                    <FormGroup check>
                      <Input
                        type="radio"
                        name="gpuLimit"
                        value="true"
                        checked={this.state.isGpuCountLimitEnabled}
                        onChange={this.handleRadioChange}
                      />{" "}
                      <Label check>Enable</Label>
                    </FormGroup>
                  </div>
                  <div>
                    <FormGroup check>
                      <Input
                        type="radio"
                        name="gpuLimit"
                        value="false"
                        checked={!this.state.isGpuCountLimitEnabled}
                        onChange={this.handleRadioChange}
                      />{" "}
                      <Label check>Disable</Label>
                    </FormGroup>
                  </div>
                </div>

                <FormGroup className="mt-3">
                  <Label for="gpuCountLimit">Set GPU Count Limit</Label>
                  <Input
                    id="gpuCountLimit"
                    type="number"
                    min="1"
                    value={this.state.gpuCountLimit}
                    onChange={(e) => this.changeGPUCountLimit(e.target.value)}
                    placeholder="Enter GPU limit"
                    disabled={!this.state.isGpuCountLimitEnabled}
                  />
                </FormGroup>
              </FormGroup>
            </Row>

            <div
              class="btn-toolbar pageBgWhite"
              role="toolbar"
              aria-label="Toolbar with button groups"
              style={{
                display: "flex",
                padding: "20px",
                marginTop: "20px",
                justifyContent: "flex-end",
                borderRadius: "0px 0px 10px 10px",
              }}
            >
              <div
                class="mr-2"
                role="group"
                aria-label="Third group"
                className="modalBtn"
                id="knowMoreFooter"
              >
                <Button
                  id="confirmbtn_list"
                  onClick={this.saveGPUPreference}
                  className="btn-detils"
                >
                  Save
                </Button>
              </div>
              <div role="group" aria-label="First group">
                <Button
                  className="btn-cancel btn btn-light"
                  onClick={this.props.toggle}
                >
                  Close
                </Button>
              </div>
            </div>
          </div>
        </div>
        {this.state.errorPopup === true ? (
          <SerraError
            Errordata={this.state.errormessage}
            ErrorPopup={this.state.errorPopup}
            setErrorMethod={this.setErrorPopupState}
            isError={this.state.isErrorHeader}
          ></SerraError>
        ) : (
          ""
        )}
        {this.state.modalLoader === true ? <SerraLoader></SerraLoader> : ""}
      </div>
    );
  }
}

export default GpuPreferences;
